﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const GenericFormHelpers_1 = require("./GenericFormHelpers");
class GenericForm extends React.Component {
    constructor() {
        super(...arguments);
        this.onFieldChange = (fieldName, fieldValue) => {
            let newFieldValues = Object.assign(Object.assign({}, this.props.valueToEdit), { [fieldName]: fieldValue });
            this.props.onChange(newFieldValues);
        };
        this.render = () => {
            let uiFieldsToRender = this.props.fields.map((item) => {
                let inputValue = (this.props.valueToEdit && this.props.valueToEdit.hasOwnProperty(item.name) && this.props.valueToEdit[item.name])
                    ? this.props.valueToEdit[item.name] : undefined;
                return GenericFormHelpers_1.generateField(item, inputValue, this.onFieldChange);
            });
            return (React.createElement(React.Fragment, null, uiFieldsToRender));
        };
    }
}
exports.GenericForm = GenericForm;
exports.default = GenericForm;
//# sourceMappingURL=GenericForm.js.map